<div class="d-flex align-items-start">
  <div class="col-5 asset-card-content-title">{{ label }}</div>
  <div class="col-7 asset-card-content-value">
    <select
      class="form-select edit-input"
      [class.is-invalid]="!!shownError"
      [class.is-placeholder]="selectedValue === null"
      [(ngModel)]="selectedValue"
      (ngModelChange)="onValueChange($event)"
    >
      <option [ngValue]="null" disabled hidden>{{ 'COMMON.SELECT' | translate }}</option>
      <option *ngFor="let option of options" [ngValue]="option.value">{{ option.label | translate }}</option>
    </select>
    <div *ngIf="shownError as shown" class="invalid-feedback d-block">
      {{ shown.key | translate: shown.params }}
    </div>
  </div>
</div>
